import { InjectionToken } from '@angular/core';

/**
 * Supported brands. The active brand is derived from the application host
 * (see {@link getBrand}) so a single build can be served under multiple brands.
 */
export enum Brand {
  Salt = 'salt',
  RocketKor = 'rocketkor',
}

export interface BrandConfig {
  brand: Brand;
  /** Human-readable brand name, used in the page title. */
  displayName: string;
  /** Path to the favicon asset. */
  favicon: string;
}

// This app renders no logo of its own (it is embedded in the integrator's page), so
// the brand surface is limited to the palette in _brands.scss plus these two values.
export const BRAND_CONFIGS: Record<Brand, BrandConfig> = {
  [Brand.RocketKor]: {
    brand: Brand.RocketKor,
    displayName: 'RocketKOR',
    favicon: './assets/images/rocket.svg',
  },
  [Brand.Salt]: {
    brand: Brand.Salt,
    displayName: 'Salt Treasury',
    favicon: './assets/images/salt-favicon.ico',
  },
};

/**
 * Resolves the active brand from the host. A host containing the word "salt"
 * activates SALT branding; everything else (including "rocketkor" hosts and the
 * local default) falls back to RocketKOR.
 */
export const getBrand = (host: string = window.location.host): Brand =>
  host.toLowerCase().includes('salt') ? Brand.Salt : Brand.RocketKor;

export const getBrandConfig = (host?: string): BrandConfig => BRAND_CONFIGS[getBrand(host)];

// Root-provided with a default factory so the token is always resolvable - in the
// app and in any TestBed - without each injector needing to register it explicitly.
export const BRAND_CONFIG = new InjectionToken<BrandConfig>('Brand Config', {
  providedIn: 'root',
  factory: () => getBrandConfig(),
});
